import script from "./OrganizationHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationHistory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__